import { useMenuSlice } from 'app/components/Menu/slice';
import { tabLevel } from 'app/components/Tabs/constants';
import * as React from 'react';
import { useDispatch } from 'react-redux';

export function useInitializeTab(id: string, type: tabLevel) {
  const {
    actions: { initializeTabs, destroyTabs },
  } = useMenuSlice();

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      initializeTabs({
        type: type,
        id: id,
      }),
    );

    return () => {
      dispatch(destroyTabs());
    };
  }, [id, dispatch, initializeTabs, destroyTabs, type]);

  return null;
}
